// extracted by mini-css-extract-plugin
export default {"post":"yvV5v","image":"lj_XC","author":"JWdU7"};